import { BaseClaims } from "./base-claims";

export class Claims extends BaseClaims {
    
    public static CanViewVetRunsTab: string = "CanViewVetRunsTab";
    public static CanViewScreeningRunsTab: string = "CanViewScreeningRunsTab";
    public static CanEditMFA: string = "CanEditMFA";
    public static CanModifyVettingListSettingsAtCustomer: string = "CanModifyVettingListSettingsAtCustomer";
    public static CanModifyCustomerPurchaserNames: string = "CanModifyCustomerPurchaserNames";
    public static CanModifyVettingListSettingsAtBusinessUnit: string = "CanModifyVettingListSettingsAtBusinessUnit";
    public static CanForceVoyageDataSubmissionReporting: string = "CanForceVoyageDataSubmissionReporting";
    public static CanGenerateExcelFiles: string = "CanGenerateExcelFiles";
    public static SkipForcedShipManagerEmailInput: string = "SkipForcedShipManagerEmailInput";
    public static CanAddCarbonAccountingDocuments: string = "CanAddCarbonAccountingDocuments";
    public static CanSubmitIncidentCloseout: string = "CanSubmitIncidentCloseout";
    public static CanRemoveCarbonAccountingDocuments: string = "CanRemoveCarbonAccountingDocuments";
    public static CanCancelCustomerDecisions: string = "CanCancelCustomerDecisions";
    public static CanReopenCancelledVets: string = "CanReopenCancelledVets";
    public static CanReopenEscalatedVets: string = "CanReopenEscalatedVets";
    public static CanCancelFbr: string = "CanCancelFbr";
    public static CanCancelCfr: string = "CanCancelCfr";
    public static CanModifyBillingDetails: string = "CanModifyBillingDetails";
    public static CanEditBillingDetailsCurrencyAmountSales: string = "CanEditBillingDetailsCurrencyAmountSales";
    public static CanModifyInspectorAppointment: string = "CanModifyInspectorAppointment";
    public static CanViewFbrResponses: string = "CanViewFbrResponses";
    public static CanViewFbrDocuments: string = "CanViewFbrDocuments";
    public static CanChangeFbrStatus: string = "CanChangeFbrStatus";
    public static CanAssignFbrRequest: string = "CanAssignFbrRequest";
    public static CanEditFbrOutcome: string = "CanEditFbrOutcome";
    public static CanViewFbrCorrespondence: string = "CanViewFbrCorrespondence";
    public static CanViewFbrEmailHistory: string = "CanViewFbrEmailHistory";
    public static CanAddFbrDocuments: string = "CanAddFbrDocuments";
    public static CanRemoveFbrDocuments: string = "CanRemoveFbrDocuments";
    public static ReopeningFBR: string = "ReopeningFBR";
    public static CanViewCarbonAccountingHistoryTrail: string = "CanViewCarbonAccountingHistoryTrail";
    public static CanAddVetTaskManually: string = "CanAddVetTaskManually";
    public static CanViewFormEmailHistory: string = "CanViewFormEmailHistory";
    public static CanContactRsOperationsWhenVetHasOutcome: string = "CanContactRsOperationsWhenVetHasOutcome";
    public static CanContactRsOperationsWhenCarbonAccountingHasOutcome: string = "CanContactRsOperationsWhenCarbonAccountingHasOutcome";
    public static CanViewRiskScoresInVetOverview: string = "CanViewRiskScoresInVetOverview";
    public static CanViewRiskScoresInScreeningOverview: string = "CanViewRiskScoresInScreeningOverview";
    public static TerminalCanTakeDecision: string = "TerminalCanTakeDecision";
    
    public static CanViewCfrDocuments: string = "CanViewCfrDocuments";
    public static CanChangeCfrStatus: string = "CanChangeCfrStatus";
    public static CanAssignCfrRequest: string = "CanAssignCfrRequest";
    public static CanViewCfrCorrespondence: string = "CanViewCfrCorrespondence";
    public static CanViewCfrEmailHistory: string = "CanViewCfrEmailHistory";
    public static CanAddCfrDocuments: string = "CanAddCfrDocuments";
    public static CanRemoveCfrDocuments: string = "CanRemoveCfrDocuments";
    public static CanAccessCFRinActivity: string = "CanAccessCFRinActivity";
    public static CanAddWindwardRuleCollectionCredential: string = "CanAddWindwardRuleCollectionCredential";
    
    public static CanDeleteZeroHarmParner: string = "CanDeleteZeroHarmParner";
    public static CanUpdateZeroHarmParner: string = "CanUpdateZeroHarmParner";
    public static CanAddZeroHarmParner: string = "CanAddZeroHarmParner";
    public static CanViewZeroHarmParner: string = "CanViewZeroHarmParner";
    //My Fleet Claims
    // removed as per PX-6404
    // public static CanAddToMyFleet: string = "CanAddToMyFleet";
    // public static CanRemoveFromMyFleet: string = "CanRemoveFromMyFleet";

    public static CanEditVetAutoCancellation: string = "CanEditVetAutoCancellation";
    public static CanEditFormAutoCancellation: string = "CanEditFormAutoCancellation";
    public static CanEditVetCriteria: string = "CanEditVetCriteria";
    public static CanEditAuthorizedUserForAmendingVettingRules: string = "CanEditAuthorizedUserForAmendingVettingRules";
    public static CanUpdateUsersCompanyAssociations: string = "CanUpdateUsersCompanyAssociations";
    public static CanRequestVet: string = "CanRequestVet";
    public static CanRequestAutoScreening: string = "CanRequestAutoScreening";
    public static CanViewVesselDocuments: string = "CanViewVesselDocuments";
    public static CanViewCompanyDocuments: string = "CanViewCompanyDocuments";
    public static CanViewVesselLists: string = "CanViewVesselLists";
    public static CanViewCompanyLists: string = "CanViewCompanyLists";
    public static CanViewCrewWelfareTab: string = "CanViewCrewWelfareTab";
    public static CanEditCompanyDetails: string = "CanEditCompanyDetails";
    public static CanRunSystemRules: string = "CanRunSystemRules";
    public static CanProcessSanctionedVet: string = "CanProcessSanctionedVet";
    public static CanProcessVetUnknownPort: string = 'CanProcessVetUnknownPort';
    public static ShowIncoTerms: string = 'ShowIncoTerms';
    public static MandatoryIncoTerms: string = 'MandatoryIncoTerms';
    public static canGenerateScreeningReport: string = 'CanGenerateScreeningReport';
    public static CanViewSafetyScoreInTasks: string = 'CanViewSafetyScoreInTasks';
    public static CanViewSafetyScoreImpactInTasks: string = 'CanViewSafetyScoreImpactInTasks';
    
    //Customers Claims
    public static CanViewCustomerDecision: string = "CanViewCustomerDecision";
    public static CanViewAutoScreeningCustomerDecision: string = "CanViewAutoScreeningCustomerDecision";
    public static CanProcessCustomerDecision: string = "CanProcessCustomerDecision";
    public static CanProcessScreeningCustomerDecisionForSubscriptions: string = "CanProcessScreeningCustomerDecisionForSubscriptions";
    public static CanProcessScreeningCustomerDecisionForRightStore: string = "CanProcessScreeningCustomerDecisionForRightStore";
    public static CanProcessAutoScreeningCustomerDecision: string = "CanProcessAutoScreeningCustomerDecision";
    public static CanApplyForWaiver: string = "CanApplyForWaiver";
    public static CanAccessCustomers: string = "CanAccessCustomers";
    public static CanEditCustomerRulesRiskSettings: string = "CanEditCustomerRulesRiskSettings";
    public static CanAccessCustomerRuleParameters: string = "CanAccessCustomerRuleParameters";
    public static CanEditCustomerRuleParameters: string = "CanEditCustomerRuleParameters";
    public static CanAccessBusinessUnitRuleParameters: string = "CanAccessBusinessUnitRuleParameters";
    public static CanAccessPortsAndTerminalsSetup: string = "CanAccessPortsAndTerminalsSetup";
    public static CanEditBusinessUnitRuleParameters: string = "CanEditBusinessUnitRuleParameters";
    public static CanEditBusinessUnitRulesRiskSettings: string = "CanEditBusinessUnitRulesRiskSettings";
    public static CanViewBUEmailAlerts: string = "CanViewBUEmailAlerts";
    public static CanEditBUEmailAlerts: string = "CanEditBUEmailAlerts";
    public static CanAccessRules: string = "CanAccessRules";
    public static CanEditRules: string = "CanEditRules";
    public static CanAccessSubtaskTypes: string = "CanAccessSubtaskTypes";
    public static CanAddRules: string = "CanAddRules";
    public static CanAddSubtaskTypes: string = "CanAddSubtaskTypes";
    public static CanRemoveRules: string = "CanRemoveRules";
    public static CanBulkUnassignRuleToACollection: string = "CanBulkUnassignRuleToACollection";
    public static CanRemoveSubtaskTypes: string = "CanRemoveSubtaskTypes";
    public static CanAddCustomers: string = "CanAddCustomers";
    public static CanDeleteCustomers: string = "CanDeleteCustomers";
    public static CanUpdateCustomers: string = "CanUpdateCustomers";
    public static CanReorderBusinessUnitRuleConfigs: string = "CanReorderBusinessUnitRuleConfigs";
    public static CanViewCustomerCarbonAccountingSettings: string = "CanViewCustomerCarbonAccountingSettings";
    public static CanEditCustomerCarbonAccountingSettings: string = "CanEditCustomerCarbonAccountingSettings";
    public static CanViewCarbonAccountingEmailAlerts: string = "CanViewCarbonAccountingEmailAlerts";
    public static CanEditCarbonAccountingEmailAlerts: string = "CanEditCarbonAccountingEmailAlerts";
    public static CanViewCarbonAccountingDefaultOverrides: string = "CanViewCarbonAccountingDefaultOverrides";
    public static CanEditCarbonAccountingDefaultOverrides: string = "CanEditCarbonAccountingDefaultOverrides";
    public static CanAddThirdPartyInspections: string = "CanAddThirdPartyInspections";
    public static CanViewSurveyColumnInTasks: string = "CanViewSurveyColumnInTasks";

    public static CanAddRuleCollections: string = "CanAddRuleCollections";
    public static CanRemoveRuleCollections: string = "CanRemoveRuleCollections";
    public static CanAssignRuleCollections: string = "CanAssignRuleCollections";
    
    public static CanAccessRuleCollectionsAtBusinessUnit: string = "CanAccessRuleCollectionsAtBusinessUnit";
    public static CanAddRuleCollectionsAtBusinessUnit: string = "CanAddRuleCollectionsAtBusinessUnit";
    public static CanRemoveRuleCollectionsAtBusinessUnit: string = "CanRemoveRuleCollectionsAtBusinessUnit";
    public static CanAddWindwardCustomerCredential: string = "CanAddWindwardCustomerCredential";

    //Vessels Claims
    public static CanAccessVessels: string = "CanAccessVessels";
    public static CanAccessCompanies: string = "CanAccessCompanies";
    public static CanFilterByVesselsHavingInspectionExpiring: string = "CanFilterByVesselsHavingInspectionExpiring";
    public static CanAccessReviewInVesselActivity: string = "CanAccessReviewInVesselActivity";
    public static CanViewReviewInVesselActivity: string = "CanViewReviewInVesselActivity";
    public static CanExportVesselDetails: string = "CanExportVesselDetails";
    public static CanAccessVesselComparison: string = "CanAccessVesselComparison";
    public static CanGenerateVesselComparisonReport: string = "CanGenerateVesselComparisonReport";
    public static CanViewSanctionedVessel: string = "CanViewSanctionedVessel";
    
    // removed as per PX-6404
    // public static CanAccessMyFleets: string = "CanAccessMyFleets";
    public static CanViewSisterVessels: string = "CanViewSisterVessels";
    public static CanAddMOCForms: string = "CanAddMOCForms";
    public static CanAddClassSurveyStatusReportForms: string = "CanAddClassSurveyStatusReportForms"; 
    public static CanRequestRightShipInspection: string = "CanRequestRightShipInspection";

    //Lists Claims
    public static CanAccessLists: string = "CanAccessLists";
    public static CanAddLists: string = "CanAddLists";
    public static CanDeleteLists: string = "CanDeleteLists";
    public static CanEditLists: string = "CanEditLists";
    public static CanAddEntityToLists: string = "CanAddEntityToLists";
    public static CanImportListItems: string = "CanImportListItems";

    //Custom Reports Claims
    public static CanAccessCustomReportsTab: string = "CanAccessCustomReportsTab";
    public static CanAddCustomReports: string = "CanAddCustomReports";
    public static CanDeleteCustomReports: string = "CanDeleteCustomReports";
    public static CanUpdateCustomReports: string = "CanUpdateCustomReports";
    public static CanAccessDetailedVetReport: string = "CanAccessDetailedVetReport";
    public static CanAccessTQsInDetailedVetReport: string = "CanAccessTQsInDetailedVetReport";
    public static CanAccessEscalationsInDetailedVetReport: string = "CanAccessEscalationsInDetailedVetReport";
    public static CanAccessPowerBiReports: string = "CanAccessPowerBiReports";    
    public static CanAccessRightshipInsights: string = "CanAccessRightshipInsights";    
    public static ShowInsightsBetaAndFreeTrialBanner: string = "ShowInsightsBetaAndFreeTrialBanner";    
    public static CanAccessCompanyInsights: string = "CanAccessCompanyInsights";    

    public static CanChangeVetStatus: string = "CanChangeVetStatus";
    public static CanChangeIncidentStatus: string = "CanChangeIncidentStatus";
    public static CanAssignCarbonAccounting: string = "CanAssignCarbonAccounting";
    public static CanViewCarbonAccountingCorrespondence: string = "CanViewCarbonAccountingCorrespondence";
    public static CanViewCarbonAccountingDocuments: string = "CanViewCarbonAccountingDocuments";
    public static CanSubmitCarbonAccounting: string = "CanSubmitCarbonAccounting";
    public static CanChangeCarbonAccountingStatus: string = "CanChangeCarbonAccountingStatus";
    public static CanAccessCarbonAccountingDashboard: string = "CanAccessCarbonAccountingDashboard";
    public static CanAccessCarbonAccountingSummaryPage: string = "CanAccessCarbonAccountingSummaryPage";
    public static CanAccessCarbonAccountingVoyageRecordsPage: string = "CanAccessCarbonAccountingVoyageRecordsPage";
    public static CanAccessCarbonAccountingEmissionsIntensityPage: string = "CanAccessCarbonAccountingEmissionsIntensityPage";
    public static CanDeleteCarbonAccountingVoyageData: string = "CanDeleteCarbonAccountingVoyageData";
    public static CanViewIncidentsCorrespondence: string = "CanViewIncidentsCorrespondence";
    public static CanAssignMisreportedStatus: string = "CanAssignMisreportedStatus";
    public static CanViewIncidentsEmailHistory: string = "CanViewIncidentsEmailHistory";
    public static CanChangePscInspectionStatus: string = "CanChangePscInspectionStatus";
    public static CanMisreportPSC: string ="CanMisreportPSC";
    public static CanEditUpdateRightShipInspection: string = "CanEditUpdateRightShipInspection";
    public static CanSendHybridInspectionEmail: string = "CanSendHybridInspectionEmail";
    public static CanSendCrewMatrixInspectionEmail: string = "CanSendCrewMatrixInspectionEmail";
    public static CanEditUpdateTankerInspection: string = "CanEditUpdateTankerInspection";
    public static CanChangeRightShipInspectionStatus: string = "CanChangeRightShipInspectionStatus";
    public static ViewRightShipInspectionCorrespondence: string = "ViewRightShipInspectionCorrespondence";
    public static CanViewTankerInspectionCorrespondence: string = "CanViewTankerInspectionCorrespondence";
    public static CanViewCargillInspectionCorrespondence: string = "CanViewCargillInspectionCorrespondence";
    public static ViewRightShipInspectionEmailHistory: string = "ViewRightShipInspectionEmailHistory";
    public static CanViewTankerInspectionEmailHistory: string = "CanViewTankerInspectionEmailHistory";
    public static CanCreateCargillInspectionRfi: string = "CanCreateCargillInspectionRfi";    
    public static CanEditCargillInspection: string = "CanEditCargillInspection";
    public static CanViewCargillInspectionEmailHistory: string = "CanViewCargillInspectionEmailHistory";
    public static CanRemoveRuleAssignments: string = "CanRemoveRuleAssignments";
    public static ShowBerthInVetRequest: string = "ShowBerthInVetRequest";
    public static CanAddVesselDocuments: string = "CanAddVesselDocuments";
    public static CanRemoveVesselDocuments: string = "CanRemoveVesselDocuments";
    public static CanAddCompanyDocuments: string = "CanAddCompanyDocuments";
    public static CanRemoveCompanyDocuments: string = "CanRemoveCompanyDocuments";
    public static CanRemoveVetDocuments: string = "CanRemoveVetDocuments";
    public static CanRemoveSafetyRatingReviewDocuments: string = "CanRemoveSafetyRatingReviewDocuments";
    public static CanAddSafetyRatingReviewDocuments: string = "CanAddSafetyRatingReviewDocuments";
    public static CanViewSafetyRatingReviewDocuments: string = "CanViewSafetyRatingReviewDocuments";
    public static CanAssignSafetyRatingReview: string = "CanAssignSafetyRatingReview";
    public static CanAccessSafetyRatingReviews: string = "CanAccessSafetyRatingReviews";
    public static CanViewSafetyRatingReviewCorrespondence: string = 'CanViewSafetyRatingReviewCorrespondence';
    public static CanViewSafetyRatingReviewEmailHistory: string = 'CanViewSafetyRatingReviewEmailHistory';
    public static CanViewSafetyRatingReviewHistoryTrail: string = 'CanViewSafetyRatingReviewHistoryTrail';
    public static CanViewSafetyRatingReviewReview: string = 'CanViewSafetyRatingReviewReview';
    public static CanAddSafetyRatingReviewRfi: string = 'CanAddSafetyRatingReviewRfi';
    public static CanAddVetDocuments: string = "CanAddVetDocuments";
    public static CanViewVetDocuments: string = "CanViewVetDocuments";
    public static CanAssignVetRequest: string = "CanAssignVetRequest";

    public static CanEditCFR: string = "CanEditCFR";
    public static CanAddCFR: string = "CanAddCFR";
    public static CanAddFBR: string = "CanAddFBR";
    public static CanAddPSC: string = "CanAddPSC";
    public static CanAddPSCDataSubmission: string = "CanAddPSCDataSubmission";
    public static CanRequireRightShipInspection: string = "CanRequireRightShipInspection";
    public static CanCreateCargillInspection: string = "CanCreateCargillInspection";
    public static CanAssignCargillInspection: string = "CanAssignCargillInspection";
    public static CanAddCargillInspectionDocument: string = "CanAddCargillInspectionDocument";
    public static CanDeleteCargillInspectionDocument: string = "CanDeleteCargillInspectionDocument";
    public static CanChangeCargillInspectionStatus: string = "CanChangeCargillInspectionStatus";
    public static CanCreateWetInspection: string = "CanCreateWetInspection";
    public static CanAddEnvironmentalVerification: string = "CanAddEnvironmentalVerification";
    public static CanRequireEnvironmentalVerification: string = "CanRequireEnvironmentalVerification";
    public static CanMergeVessels: string = "CanMergeVessels";
    public static ReopeningGHG: string = "ReopeningGHG";
    public static CanAddEexiVerification: string = "CanAddEexiVerification";
    public static CanAddIncident: string = "CanAddIncident";
    public static CanReviewFBR: string = "CanReviewFBR";
    public static ShowChangestatustoAwaitingcheckbox: string = "ShowChangestatustoAwaitingcheckbox";
    public static ShowSaveandFinaliseButton: string = "ShowSaveandFinaliseButton";

    public static CanAccessVettingContacts: string = "CanAccessVettingContacts";

    public static CanViewAllBusinessUnits: string = "CanViewAllBusinessUnits";
    public static CanViewMyBusinessUnit: string = "CanViewMyBusinessUnit";
    public static CanAddBusinessUnits: string = "CanAddBusinessUnits";
    public static CanEditBusinessUnits: string = "CanEditBusinessUnits";
    public static CanRemoveBusinessUnitSettings: string = "CanRemoveBusinessUnitSettings";
    public static CanManageRoles: string = "CanManageRoles";
    public static CanViewAllPeople: string = "CanViewAllPeople";
    public static CanViewPeopleInMyBusinessUnit: string = "CanViewPeopleInMyBusinessUnit";    
    public static CanAddPeopleRightShipUsers: string = "CanAddPeopleRightShipUsers";
    public static CanAddPeopleCustomers: string = "CanAddPeopleCustomers";
    public static CanExportPeople: string = "CanExportPeople";
    public static CanEditPeopleRightShipUsers: string = "CanEditPeopleRightShipUsers";
    public static CanEditPeopleCustomers: string = "CanEditPeopleCustomers";
    public static CanDeletePeople: string = "CanDeletePeople";
    public static CanManageLockedRoles: string = "CanManageLockedRoles";
    public static CanAccessMySubscription: string = "CanAccessMySubscription";
    public static CanAccessCustomerSubscriptions: string ="CanAccessCustomerSubscriptions";
    public static ShowShipToShip: string = "ShowShipToShip";
    public static ShowTimeCharter: string = "ShowTimeCharter";
    public static ShowLiaiseWithShipManagerSection: string = "ShowLiaiseWithShipManagerSection";


    // Tasks Claims
    public static CanAccessPSCs: string = "CanAccessPSCs";
    public static CanAccessRightShipInspections: string = "CanAccessRightShipInspections";
    public static CanAccessWetInspections: string = "CanAccessWetInspections";
    public static CanAccessCargillInspections: string = "CanAccessCargillInspections";
    public static CanAccessForms: string = "CanAccessForms";
    public static CanAccessFBRs: string = "CanAccessFBRs";
    public static CanAccessDataSubmissions: string = "CanAccessDataSubmissions";
    public static CanAccessCrewWelfare: string = "CanAccessCrewWelfare";
    public static CanAccessCFRs: string = "CanAccessCFRs";
    public static CanAccessINCs: string = "CanAccessINCs";
    public static CanAccessVETs: string = "CanAccessVETs";
    public static CanAccessInspectors: string = "CanAccessInspectors";
    public static CanAccessCarbonAccounting: string = "CanAccessCarbonAccounting";
    public static CanAccessEnvironmentals: string = "CanAccessEnvironmentals";
    public static CanAccessAutoScreening: string = "CanAccessAutoScreening";
    public static CanAccessTradeCheck: string = "CanAccessTradeCheck";
    public static CanAccessVesselHealthCheck: string = "CanAccessVesselHealthCheck";
    public static CanAccessPreArrivalCheck: string = "CanAccessPreArrivalCheck";
    public static CanLinkAutoScreeningWithFullVet: string = "CanLinkAutoScreeningWithFullVet";
    public static CanSubmitDataAboutVessel: string = "CanSubmitDataAboutVessel";

    public static CanViewVesselAgeInTasks: string = "CanViewVesselAgeInTasks";
    public static CanViewIncidentZoneInTasks: string = "CanViewIncidentZoneInTasks";
    
    public static CanViewPSCCorrespondence: string = 'CanViewPSCCorrespondence';
    public static CanViewPSCEmailHistory: string = 'CanViewPSCEmailHistory';

    public static CanViewVesselCorrespondence: string = 'CanViewVesselCorrespondence';
    public static CanViewEEDIEVDIFormula: string = 'CanViewEEDIEVDIFormula';
    public static RightShipUser: string = 'RightShipUser';
    public static CanOverridePriceInAppPurchase: string = 'CanOverridePriceInAppPurchase';
    public static LinksForInspection: string = 'LinksForInspection';
    public static CanChangeShipManagerEmails: string = 'CanChangeShipManagerEmails';
    public static CanContactRightshipOperations: string = 'CanContactRightshipOperations';
    public static ImpersonateBUForRequestingVet: string = 'ImpersonateBUForRequestingVet';
    public static GhgAdmin: string = 'GhgAdmin';
    public static CanViewVettingCriteria: string = 'CanViewVettingCriteria';
    public static CanBulkUpdateUsers: string = 'CanBulkUpdateUsers';
    public static CanResetMfaEnrollment: string = "CanResetMfaEnrollment";

    public static EditVesselDetails: string = 'EditVesselDetails';
    public static CanViewVesselDetailsEdits: string = 'CanViewVesselDetailsEdits';
    public static CanViewEmailHistory: string = "CanViewEmailHistory";

    public static CanAccessPipelines: string = "CanAccessPipelines";
    public static CanAccessPipelineExecutions: string = "CanAccessPipelineExecutions";
    public static CanAccessSurvivorshipRules: string = "CanAccessSurvivorshipRules";
    public static CanAccessSurvivorshipRuleFailures: string = "CanAccessSurvivorshipRuleFailures";
    public static CanViewAllLists: string = "CanViewAllLists";
    public static CanEditProtectedList: string = "CanEditProtectedList";
    public static CanEditProtectedListItem: string = "CanEditProtectedListItem";


    public static ShowSafetyScoreChangeFullDetails: string = "ShowSafetyScoreChangeFullDetails";
    public static DocAndVesselPerformanceReports: string = "DocAndVesselPerformanceReports";
    public static CanViewVettingCorrespondence: string = 'CanViewVettingCorrespondence';
    public static CanViewVettingEmailHistory: string = 'CanViewVettingEmailHistory';
    public static CanEditVetRequestContactDetails: string = 'CanEditVetRequestContactDetails';
    public static CanAddVetRequestContactDetails: string = 'CanAddVetRequestContactDetails';
    public static CanViewHistoryTrail: string = 'CanViewHistoryTrail';
    public static CanViewRightShipInspectionHistoryTrail: string = 'CanViewRightShipInspectionHistoryTrail';
    public static CanViewIncidentOverrideHistory: string = 'CanViewIncidentOverrideHistory';
    public static CanViewIncidentEdits: string = 'CanViewIncidentEdits';
    public static CanEditIncidentDetails: string = 'CanEditIncidentDetails';
    public static CanEditClosedIncidentDetails: string = 'CanEditClosedIncidentDetails';
    public static CanEditIncidentCasualtyOrDemolition: string = 'CanEditIncidentCasualtyOrDemolition';
    public static CanViewCargillInspectionHistoryTrail: string = 'CanViewCargillInspectionHistoryTrail';
    public static CanViewVettedInTasks: string = 'CanViewVettedInTasks';
    public static CanViewCategoryChangesInTasks: string = 'CanViewCategoryChangesInTasks';

    public static CanAccessVettingAttributes: string = 'CanAccessVettingAttributes';

    public static CanAccessSafetyScoreBenchmarking: string = 'CanAccessSafetyScoreBenchmarking';
    public static CanAccessSafetyScoreSubscoreSummary: string = 'CanAccessSafetyScoreSubscoreSummary';
    public static CanAccessSafetyScoreSubscoreBoundaries: string = 'CanAccessSafetyScoreSubscoreBoundaries';
    public static CanAccessSafetyScoreVesselScores: string = 'CanAccessSafetyScoreVesselScores';
    public static CanAccessSafetyScoreDocScores: string = 'CanAccessSafetyScoreDocScores';
    public static CanAccessSafetyScoreFlagScores: string = 'CanAccessSafetyScoreFlagScores';
    public static CanAccessSafetyScoreClassScores: string = 'CanAccessSafetyScoreClassScores';

    public static CanAddFbrRfi: string = 'CanAddFbrRfi';
    public static CanAddVetRfi: string = 'CanAddVetRfi';
    public static CanAddCarbonAccountingRfi: string = 'CanAddCarbonAccountingRfi';
    public static CanContactVetRequestor: string = 'CanContactVetRequestor';

    public static CanAssignPSC: string = 'CanAssignPSC';
    public static CanAssignIncident: string = 'CanAssignIncident';
    public static CanOverrideIncidentDetails: string = 'CanOverrideIncidentDetails';
    public static CanOverridePscDetails: string = 'CanOverridePscDetails';
    public static CanViewGHGCorrespondence: string = 'CanViewGHGCorrespondence';
    public static CanViewGHGEmailHistory: string = 'CanViewGHGEmailHistory';
    public static CanViewIncidentDocuments: string = 'CanViewIncidentDocuments';
    public static CanViewPSCDocuments: string = 'CanViewPSCDocuments';
    public static CanViewPSCOverrideHistory: string = 'CanViewPSCOverrideHistory';
    public static CanViewPSCEdits: string = "CanViewPSCEdits";
    public static CanEditPSCDetails: string = 'CanEditPSCDetails';
    public static CanSubmitPscCloseout: string = 'CanSubmitPscCloseout';
    public static CanViewSourceColumnInTasksPSC: string = 'CanViewSourceColumnInTasksPSC';
    public static CanActivatePSCinSafetyScore = "CanActivatePSCinSafetyScore";

    public static ReopeningVET: string = 'ReopeningVET';

    public static ShowAIExperiment: string = 'ShowAIExperiment';
    public static CanCancelVet: string = 'CanCancelVet';

    public static CanViewVesselNotes: string = 'CanViewVesselNotesTab';
    public static CanAddPrivateNotes: string = 'CanAddPrivateNotes';
    public static CanViewPrivateNotes: string = 'CanViewPrivateNotes';
    public static CanViewVetNotes: string = 'CanViewVetNotesTab';
    public static CanViewCompanyNotes: string = 'CanViewCompanyNotesTab';
    public static CanViewFBRNotes: string = 'CanViewFBRNotesTab';
    public static CanViewCFRNotes: string = 'CanViewCFRNotesTab';
    public static CanViewRightShipInspectionNotes: string = 'CanViewRightShipInspectionNotesTab';
    public static CanViewIncidentNotes: string = 'CanViewIncidentNotesTab';
    public static CanViewPSCNotes: string = 'CanViewPSCNotesTab';
    public static CanViewGHGNotes: string = 'CanViewGHGNotesTab';

    public static CanEditCorrespondenceEmails: string = 'CanEditCorrespondenceEmails';
    public static CanSubmitVetToRSByHostedCustomer: string = 'CanSubmitVetToRSByHostedCustomer';
    public static CanChangeValidityDate: string = "CanChangeValidityDate";
    public static EditRFICorrespondence: string = "EditRFICorrespondence";
    public static ShowTransactionNumber: string = "ShowTransactionNumber";

    public static CanAccessPSCInActivity: string = "CanAccessPSCInActivity";
    public static CanAccessIncidentInActivity: string = "CanAccessIncidentInActivity";
    public static CanAccessEnvironmentalInActivity: string = "CanAccessEnvironmentalInActivity";
    public static CanAccessRSInspectionsInActivity: string = "CanAccessRSInspectionsInActivity";
    public static CanAccessFBRInActivity: string = "CanAccessFBRInActivity";
    public static CanAccessDataSubmissionsInActivity: string = "CanAccessDataSubmissionsInActivity";
    
    public static CanCreateRFIInIncidents: string = "CanCreateRFIInIncidents";
    public static CanCreateRFIInPSC: string = "CanCreateRFIInPSC";

    public static CanViewRightShipInspectionsInVesselActivity: string = "CanViewRightShipInspectionsInVesselActivity";
    public static CanViewWetInspectionsInVesselActivity: string = "CanViewWetInspectionsInVesselActivity"
    public static CanViewCargillInspectionsInVesselActivity: string = "CanViewCargillInspectionsInVesselActivity"
    public static CanViewDataSubmissionsInVesselActivity: string = "CanViewDataSubmissionsInVesselActivity";
    public static CanViewLodInActivities: string = "CanViewLodInActivities";
    public static CanViewCotpInActivities: string = "CanViewCotpInActivities";
    public static CanViewAwaitingResponseLT20DaysInTasks: string = "CanViewAwaitingResponseLT20DaysInTasks";

    public static CanAccessSafetyScoreChangeInActivity: string = "CanAccessSafetyScoreChangeInActivity";
    
    public static CanAccessGHGRatingPeerGroup: string = "CanAccessGHGRatingPeerGroup";
    public static CanEditRSRuleParameters: string = "CanEditRSRuleParameters";
    
    public static ShowSafetyScore: string = "ShowSafetyScore";
    public static ShowGHG: string = "ShowGHG";

    public static CanAccessVesselGHGRating: string = "CanAccessVesselGHGRating";
    public static CanAccessVesselOperationalMetrics: string = "CanAccessVesselOperationalMetrics";
    public static ShowEEXIComplianceNotification: string = "ShowEEXIComplianceNotification";
    public static ShowWarningInVesselsOperationalMetrics: string = "ShowWarningInVesselsOperationalMetrics";
    public static CanAccessFbrPerformance: string = "CanAccessFbrPerformance";
    public static CanAccessVesselOverview: string = "CanAccessVesselOverview";
    public static CanAccessVesselDetails: string = "CanAccessVesselDetails";
    public static CanAccessVesselActivities: string = "CanAccessVesselActivities";
    public static CanDownloadDOCPerformance: string = "CanDownloadDOCPerformance";
    public static CanDownloadVesselsAsExcelOrPdf: string = "CanDownloadVesselsAsExcelOrPdf";

    public static CanSeeListsHistoryTrail: string = "CanSeeListsHistoryTrail";
    public static CanAccessListAlerts: string = "CanAccessListAlerts";
    public static CanAccessListPSCPerformance: string = "CanAccessListPSCPerformance";
    public static CanEditListItems: string = "CanEditListItems";
    public static CanAccessListsActions: string = "CanAccessListsActions";

    public static CanAccessDOCFleetOverview: string = "CanAccessDOCFleetOverview";
    public static CanAccessDOCFleetTable: string = "CanAccessDOCFleetTable";

    public static DataSubmissionUser: string = "DataSubmissionUser";
    
    public static CanClearVesselMous: string = "CanClearVesselMous";
    public static CanAcceptFirstReview: string = "CanAcceptFirstReview";
    public static CanAcceptSecondReview: string = "CanAcceptSecondReview";
    public static CanRequestSafetyScoreReview: string = "CanRequestSafetyScoreReview";
    public static ShowCrewWelfareInVessel: string = "ShowCrewWelfareInVessel";
    public static ShowCrewWelfareInCompany: string = "ShowCrewWelfareInCompany";
    public static ShowCrewWelfareBadgeInCompany: string = "ShowCrewWelfareBadgeInCompany";
    public static CanViewSafetyRatingReviewNotes: string = "CanViewSafetyRatingReviewNotesTab";

    public static ReopeningPsc: string = 'ReopeningPsc';
    public static ReopeningIncident: string = 'ReopeningIncident';
    
    public static CanReopen: string = "CanReopen";
    public static CanCancel: string = "CanCancel";
    public static CanInvalidate: string = "CanInvalidate";

    public static CanReopenCancelledRSInspection: string = "CanReopenCancelledRSInspection";
    public static CanEditExemptRightShipInspectionUntil: string = "CanEditExemptRightShipInspectionUntil";
    public static CanCreateInternalRfi: string = "CanCreateInternalRfi";

    public static ShowGhgIntensity: string = "ShowGhgIntensity";

    public static CanCreateFormTask: string = "CanCreateFormTask";
    public static CanChangeInspectionCompany: string = "CanChangeInspectionCompany";
    public static CanChangeRSInspectionInspector: string = "CanChangeRSInspectionInspector";
    public static CanAccessRSInspectorReport: string = "CanAccessRSInspectorReport";
    public static CanChangeInspectionWorkflow: string = "CanChangeInspectionWorkflow";
    public static ShowIncludesBallastLeg: string = "ShowIncludesBallastLeg";
    public static CanAccessVoyageDataRecords: string = "CanAccessVoyageDataRecords";
    public static CanAccessUploadFileButtonAfterStatusCompleted: string = "CanAccessUploadFileButtonAfterStatusCompleted";
    public static CanComputeVoyageEmissions: string = "CanComputeVoyageEmissions";
    public static CanAssignRightShipInspection: string = "CanAssignRightShipInspection";
    public static CanAssignTankerInspection: string = "CanAssignTankerInspection";
    public static CanViewInspectionGradingBadge: string = "CanViewInspectionGradingBadge";

    public static CanEditPscDeficiencyCorrectiveAction: string = "CanEditPscDeficiencyCorrectiveAction";
    public static CanEditPscDeficiencyPreventiveAction: string = "CanEditPscDeficiencyPreventiveAction";
    public static CanEditPscDeficiencyImmediateCause: string = "CanEditPscDeficiencyImmediateCause";
    public static CanEditPscDeficiencyRootCause: string = "CanEditPscDeficiencyRootCause";
    
    //MEP claims
    public static CanViewPortHome: string = "CanViewPortHome";
    public static CanViewPortDashboard: string = "CanViewPortDashboard";
    public static CanManageEmissionTargets: string = "CanManageEmissionTargets";
    public static CanCreateOrUpdateEmissionTargets: string = "CanCreateOrUpdateEmissionTargets";
    public static CanViewYearOnYear: string = "CanViewYearOnYear";
    public static CanViewPortVessels: string = "CanViewPortVessels";
    public static CanDownloadPortVessels: string = "CanDownloadPortVessels";
    public static CanViewPortInsights: string = "CanViewPortInsights";
    public static CanGeneratePortDashboardReport: string = "CanGeneratePortDashboardReport";
    public static CanViewPortAbout: string = "CanViewPortAbout";
    public static CanViewPortTerminology: string = "CanViewPortTerminology";
    public static CanViewScenarioPlanning: string = "CanViewScenarioPlanning";

    public static MandatoryPscDeficiencyCorrectiveAction: string = "MandatoryPscDeficiencyCorrectiveAction";
    public static MandatoryPscDeficiencyPreventiveAction: string = "MandatoryPscDeficiencyPreventiveAction";
    public static MandatoryPscDeficiencyImmediateCause: string = "MandatoryPscDeficiencyImmediateCause";
    public static MandatoryPscDeficiencyRootCause: string = "MandatoryPscDeficiencyRootCause";

    public static CanEditInspectionReportLevel1: string = "CanEditInspectionReportLevel1";
    public static CanEditInspectionReportLevel2: string = "CanEditInspectionReportLevel2";

    public static CanAddVessel: string = "CanAddVessel";

    public static CanAccessScreeningInActivity = "CanAccessScreeningInActivity";

    public static CanMoveUsers = "CanMoveUsers";

    public static ReopeningCFR = "ReopeningCFR";

    public static CanAccessPortsAndTerminals = "CanAccessPortsAndTerminals";

    public static IsRightStoreEnabled: string = "IsRightStoreEnabled";
    public static ShowRightStoreLink: string = "ShowRightStoreLink";
    public static ShowRightStoreBanner: string = "ShowRightStoreBanner";

    //Budgets
    public static GetAllBudgets: string = "GetAllBudgets";

    public static CanProcessGradeFinding: string = "CanProcessGradeFinding";
    public static CloseInspectionWithoutGradingFindings: string = "CloseInspectionWithoutGradingFindings";

    // Companies Claims
    public static ActivateDOCSubscoreForecastReport: string = "ActivateDOCSubscoreForecastReport";

    //My Vessels app
    public static ShowRightFleetStarterLink: string = "ShowRightFleetStarterLink";
    public static CanAddVesselRightFLEETStarter: string = "CanAddVesselRightFLEETStarter";

    //PSC RiskIQ
    public static CanAccessPSCRiskIQMenu: string = "CanAccessPSCRiskIQMenu";

    public static CanAccessDOCSubscoreHybridRules: string = "CanAccessDOCSubscoreHybridRules";
}
